import React, { useMemo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { defineMessages, useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import AdvancedHotkey from './component';
import { startBatchesShipmentPurchase } from '../../../store/batches/purchase/batches.purchase.actions';
import { useIsAccountEmailVerifiedSellerSetting } from '../../../hooks/use-seller-setting';
import { useModal } from '../../../hooks/use-modal';
import { VerifyEmailModal } from '../../../components/verify-email-modal';
import { PROCESS_BATCH } from '../../../constants/email-resend-source';

export const messages = defineMessages({
  name: {
    description: 'process batch hotkey',
    defaultMessage: 'Process the current open batch',
    id: '1O4mIv',
  },
});

export const hotkey = ['p', 'b'];
export const barcodeContent = '+S8N5CQD38RKD=';

const ProcessBatchHotkey = ({ children, batchId, disabled }) => {
  const isAccountEmailVerified = useIsAccountEmailVerifiedSellerSetting();

  const { close: closeUnverifiedModal, isOpen: isUnverifiedModalOpen, open: openUnverifiedModal } = useModal();
  const intl = useIntl();
  const dispatch = useDispatch();
  const onUpdate = useCallback(() => {
    if (!isAccountEmailVerified) {
      openUnverifiedModal();
      return;
    }
    // TODO: Add a check to see if the seller's wallet is setup or not - Greg S. 10/1/24
    dispatch(startBatchesShipmentPurchase(batchId, false));
  }, [isAccountEmailVerified, dispatch, batchId, openUnverifiedModal]);
  const hotkeyMetadata = useMemo(
    () => ({
      barcode: barcodeContent,
      displayHotkeyStrings: ['pb'],
      hotkey,
      handler: onUpdate,
      name: intl.formatMessage(messages.name),
      legacyCategory: 'general',
      doNotTrack: true,
    }),
    [intl, onUpdate],
  );

  if (disabled) {
    return children;
  }

  return (
    <>
      <AdvancedHotkey hotkey={hotkeyMetadata}>{children}</AdvancedHotkey>
      {isUnverifiedModalOpen && <VerifyEmailModal closeUnverifiedModal={closeUnverifiedModal} source={PROCESS_BATCH} />}
    </>
  );
};

ProcessBatchHotkey.propTypes = {
  children: PropTypes.node.isRequired,
  batchId: PropTypes.string,
  disabled: PropTypes.bool.isRequired,
};

export default ProcessBatchHotkey;
